import React, { useContext } from "react";
import { Col, Row, Typography } from "antd";

import { DaytimeTouristContext } from "./context-view";
import { daytimetouristInitialValues as initialValues } from "./initialvalues/initialValues";

const { Paragraph, Title } = Typography;

const PHResidentListView = () => {
  let { pageData } = useContext(DaytimeTouristContext);
  const data = pageData?.data || initialValues;

  return (
    <>
      <Row gutter={10}>
        <Col span={14}> Province:</Col>
        <Col span={5}>
          <Paragraph level={4}> Male </Paragraph>
        </Col>
        <Col span={5}>
          <Paragraph level={4}> Female </Paragraph>
        </Col>
      </Row>

      {data && data["phResident"]?.length > 0 ? (
        data["phResident"].map((items, index) => (
          <Row
            gutter={10}
            className={"row-darken"}
            justify="space-between"
            align="center"
          >
            <Col span={14}>{items?.["country"] || items?.["province"]}</Col>
            <Col span={5}>{items?.["male"] || 0}</Col>
            <Col span={5}>{items?.["female"] || 0}</Col>
          </Row>
        ))
      ) : (
        <Row className={"row-darken"} justify="center" align="center">
          <Title level={5}> Nothing to show here ...</Title>
        </Row>
      )}
    </>
  );
};

export default PHResidentListView;
